import { Appeal } from "components/organisms/Appeal";

interface IProps {
    theme: "light" | "dark";
}

export const AppealPage = ({theme}: IProps) => {
    return (
        <Appeal theme={theme} />
    )
}